(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5801],{

/***/ 6138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ SignUp; }
});

// EXTERNAL MODULE: ./layouts/Default.js + 5 modules
var Default = __webpack_require__(87607);
// EXTERNAL MODULE: ./components/blocks/Wrapper.js
var Wrapper = __webpack_require__(80819);
// EXTERNAL MODULE: ./components/blocks/Container.js
var Container = __webpack_require__(75046);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCircleNotch.js
var faCircleNotch = __webpack_require__(19961);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(21737);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 3 modules
var TextField = __webpack_require__(61903);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormGroup/FormGroup.js + 1 modules
var FormGroup = __webpack_require__(53457);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 6 modules
var Checkbox = __webpack_require__(85071);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(52359);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/AdapterDayjs/index.js + 1 modules
var AdapterDayjs = __webpack_require__(26829);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/DesktopDatePicker/DesktopDatePicker.js + 133 modules
var DesktopDatePicker = __webpack_require__(32412);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(41248);
// EXTERNAL MODULE: ./lib/features/authSlice.js
var authSlice = __webpack_require__(89605);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./components/forms/SignupForm.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







 // import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';







var validationSchema = es/* object */.Ry({
  email: es/* string */.Z_().email().max(50, "Email should not be more than 50 characters").required("Please enter your email"),
  password: es/* string */.Z_().min(8, 'Password should be more than 8 characters').max(50, "Password should not be more than 50 characters").required("Please enter a password").matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/, 'Need at lease one lowercase, one uppercase, one number'),
  rePassword: es/* string */.Z_().required("Please confirm your password").oneOf([es/* ref */.iH('password'), null], "Password doesn't match") // dob: yup
  //   .object()
  //   .required("Please confirm your date of birth")

});
function SignupForm(_ref) {
  var t = _ref.t,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? function () {} : _ref$onSuccess;
  var dispatch = (0,react_redux_es/* useDispatch */.I0)();

  var _useState = (0,react.useState)(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = (0,react.useState)(false),
      success = _useState2[0],
      setSuccess = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = (0,react.useState)(dayjs_min_default()()),
      dob = _useState4[0],
      setDob = _useState4[1];

  var _useState5 = (0,react.useState)(dayjs_min_default()()),
      maxDate = _useState5[0],
      setMaxDate = _useState5[1];

  var initDob = function initDob() {
    var today = dayjs_min_default()();
    var max = dayjs_min_default()().set('year', today.year() - 18);
    setMaxDate(max);
    setDob(dayjs_min_default()(max).format('YYYY/MM/DD'));
  };

  (0,react.useEffect)(function () {
    initDob();
  }, []);

  var handleDobChange = function handleDobChange(val) {
    var temp = dayjs_min_default()(val).format('YYYY/MM/DD');
    console.log('changing dob: ', temp);
    setDob(temp);
  };

  var form = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      email: '',
      password: '',
      rePassword: '',
      dob: '1990/01/01',
      isBusinessUser: false
    },
    validationSchema: validationSchema,
    onSubmit: function onSubmit(cred, actions) {
      console.log('submitting: ', cred);
      cred.dob = dob;
      setLoading(true);
      setSuccess(false);
      setError(false);
      dispatch((0,authSlice/* signUpWithEmail */.Yb)(cred)).unwrap().then(function () {
        setLoading(false);
        setSuccess(true);
        actions.resetForm();
        onSuccess();
      })["catch"](function (e) {
        setError((e === null || e === void 0 ? void 0 : e.message) || 'Unable to sign up, please try again later.');
        setLoading(false);
      });
    }
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [success && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Alert/* default */.Z, {
      severity: 'success',
      className: 'w-full mb-4',
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        className: 'font-semibold',
        children: t('home:signUpSuccessTitle')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), t('home:signUpSuccessContent')]
    }), error && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
      severity: 'error',
      className: 'w-full mb-4',
      children: error
    }), success ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
      onSubmit: form.handleSubmit,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
        fullWidth: true,
        id: "email",
        name: "email",
        label: t('home:email'),
        value: form.values.email,
        onChange: form.handleChange,
        error: form.touched.email && Boolean(form.errors.email),
        helperText: form.touched.email && form.errors.email,
        className: 'mb-4'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
        fullWidth: true,
        id: "password",
        name: "password",
        label: t('home:password'),
        type: "password",
        value: form.values.password,
        onChange: form.handleChange,
        error: form.touched.password && Boolean(form.errors.password),
        helperText: form.touched.password && form.errors.password,
        className: 'mb-4'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
        fullWidth: true,
        id: "rePassword",
        name: "rePassword",
        label: t('home:confirmPassword'),
        type: "password",
        value: form.values.rePassword,
        onChange: form.handleChange,
        error: form.touched.rePassword && Boolean(form.errors.rePassword),
        helperText: form.touched.rePassword && form.errors.rePassword,
        className: 'mb-4'
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LocalizationProvider/* LocalizationProvider */._, {
        dateAdapter: AdapterDayjs/* AdapterDayjs */.y,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopDatePicker/* DesktopDatePicker */.$, {
          fullWidth: true,
          label: t('home:dob'),
          inputFormat: "MM/DD/YYYY",
          value: dob,
          onChange: handleDobChange,
          renderInput: function renderInput(params) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, _objectSpread({}, params));
          },
          className: 'mb-4',
          maxDate: maxDate
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormGroup/* default */.Z, {
        className: 'mb-4 w-full',
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormControlLabel/* default */.Z, {
          label: t('home:businessUser'),
          control: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox/* default */.Z, {
            id: "isBusinessUser",
            name: "isBusinessUser",
            checked: form.values.isBusinessUser,
            onChange: form.handleChange
          })
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        color: "primary",
        className: '!bg-[#108085]',
        variant: "contained",
        size: 'large',
        fullWidth: true,
        disabled: loading,
        startIcon: loading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_es/* FontAwesomeIcon */.G, {
          icon: faCircleNotch/* faCircleNotch */.IJ,
          className: 'animate-spin-fast'
        }),
        type: "submit",
        children: t('home:signUp')
      })]
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 32 modules
var esm = __webpack_require__(57731);
;// CONCATENATED MODULE: ./pages/sign-up.js









var __N_SSP = true;
function SignUp() {
  var router = (0,next_router.useRouter)();

  var handleSignUpSuccess = function handleSignUpSuccess() {};

  var _useTranslation = (0,esm/* useTranslation */.$G)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper/* default */.Z, {
    className: 'py-36',
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
      className: 'max-w-sm m-auto',
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
        className: 'text-3xl font-bold text-center mb-8',
        children: t('home:signUp')
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupForm, {
        onSuccess: handleSignUpSuccess,
        t: t
      })]
    })
  });
}

SignUp.getLayout = function getLayout(page) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Default/* default */.Z, {
    children: page
  });
};

/***/ }),

/***/ 12295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up",
      function () {
        return __webpack_require__(6138);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,196,2435,6886,5876,7607,9774,2888,179], function() { return __webpack_exec__(12295); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);